import React from "react";

interface IProps {
  path: string;
  className?: string;
  onClick?: () => void;
  alt?: string;
}

const ReactSVG: React.FC<IProps> = ({
  path,
  className,
  onClick,
  alt,
}: IProps) => {
  return <img src={path} className={className} onClick={onClick} alt={alt} />;
};

export default ReactSVG;

export { IProps as IReactSVG };
